export default __webpack_public_path__ + "static/media/offerbg.15e654a7.png";